/**
 * Чат «перевозчик ↔ логист» по заявке (раздел 15.2). Таблица lot_chat_messages.
 * Один тред = пара (лот, компания). Перевозчики друг друга не видят; логисты видят все треды лота.
 */
import type { LotStatus } from "./enums";

export const CHAT_DIRECTIONS = ["carrier", "logist"] as const;
/** carrier — написал перевозчик (из бота), logist — написал сотрудник портала. */
export type ChatDirection = (typeof CHAT_DIRECTIONS)[number];

/** Чат доступен, пока заявка не оплачена и не отменена; у черновика получателей ещё нет. */
export const CHAT_CLOSED_STATUSES: readonly LotStatus[] = ["draft", "paid", "cancelled"];
export const isChatOpen = (status: LotStatus): boolean => !CHAT_CLOSED_STATUSES.includes(status);

export const CHAT_MAX_TEXT = 2000;

export type ChatMessage = {
  id: string;
  lotId: string;
  companyId: string;
  direction: ChatDirection;
  authorUserId: string | null;
  /** ФИО сотрудника для logist-сообщений; null для перевозчика. */
  authorName: string | null;
  text: string;
  /** message_id в Telegram: для logist — доставлено перевозчику, для carrier — исходное сообщение. */
  telegramMessageId: number | null;
  createdAt: string;
  readAt: string | null;
};

/** Тред с одной компанией в карточке лота. */
export type ChatThread = {
  companyId: string;
  companyName: string;
  telegramLinked: boolean;
  /** Непрочитанных сообщений от перевозчика. */
  unreadCount: number;
  lastMessageAt: string | null;
  messages: ChatMessage[];
};

/** Получатель лота, с которым логист может начать переписку. */
export type ChatCompany = { companyId: string; companyName: string; telegramLinked: boolean };

/** GET /api/lots/:id/chat */
export type LotChat = {
  open: boolean;
  threads: ChatThread[];
  companies: ChatCompany[];
};

/** Строка сводного списка «Чаты» в админке (GET /api/admin/chats). */
export type AdminChatThread = {
  lotId: string;
  lotNumber: string;
  lotStatus: LotStatus;
  companyId: string;
  companyName: string;
  messagesCount: number;
  unreadCount: number;
  lastMessage: { direction: ChatDirection; text: string; createdAt: string };
};
